const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;
import fpSuteren from './img-10.jpg';
import fpPrizemi from './img-11.jpg';
import fpPodkrovi from './img-12.jpg';

const floorPlanFiles = new Set(['./img-10.jpg', './img-11.jpg', './img-12.jpg']);

const sorted = Object.entries(photoModules)
  .filter(([path]) => !floorPlanFiles.has(path))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const podoliImages: string[] = sorted;

export const podoliFloorPlans = [
  { image: fpPrizemi, label: "Půdorys – přízemí" },
  { image: fpPodkrovi, label: "Půdorys – podkroví" },
  { image: fpSuteren, label: "Půdorys – suterén" },
];
